import {
  AccountApiStatus,
  AccountMembershipRole,
  type UserDataResponse,
} from '@safc/api-client';
import { createContext } from 'react';

import type {
  CensoredUnitInfoResponse,
  PublicCensoredUnitInfoResponse,
} from '../api/unit/unit.types.js';

const initiateAccountRoles: AccountMembershipRole[] = [AccountMembershipRole.accountRepFullAccess, AccountMembershipRole.accountRepInitiator];

/** New concept to replace abilities */
export const getPermissions = ({ user }: { user?: UserDataResponse }) => ({
  unit: {
    canSetNote: ({ unit }: { unit: CensoredUnitInfoResponse | PublicCensoredUnitInfoResponse }) => {
      if (!user) {
        return false;
      }

      const activeAccountIds = new Set(user.accounts.filter(a => a.status === AccountApiStatus.active).map(a => a.id));

      if (unit.status === 'retired') {
        return user.isRegistryAdmin;
      }

      if (unit.status !== 'active') {
        return false;
      }

      return user.isRegistryAdmin
        || user.accountMemberships.some((m) => {
          return activeAccountIds.has(m.accountId) && m.accountId === unit.ownerId && initiateAccountRoles.includes(m.role);
        });
    },
  },
});

export const PermissionContext = createContext<UserPermissions>({
  unit: {
    canSetNote: () => false,
  },
});

export type UserPermissions = ReturnType<typeof getPermissions>;
